exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small{max-width:600px;margin:150px auto}.chart-container{position:relative;margin:auto;height:80vh;width:80vw}", ""]);

// exports
